<template src="./AdminEvents.html"></template>

<script>
export default {
  name: 'admin-events'
}
</script>

<style lang="scss" scoped src="./AdminEvents.scss">
</style>